import { z } from 'zod';

export const createUpdateClientUserFormSchema = z.object({
  name: z.string()
    .trim()
    .min(1, 'Name is required.')
    .max(50, { message: 'Name must be less than 50 characters.' }),
  email: z.string()
    .trim()
    .min(1, 'Email is required.')
    .email('Must be a valid email address.')
    .min(5, 'Must be a valid email address.')
    .max(255, 'Email must be less than 255 characters.'),
  enabledFeaturesCapsule: z.array(z.string()),
  enabledFeaturesMobile: z.array(z.string())
}).required();

export const createUpdateClientUserWithGeoFormSchema = z.object({
  name: z.string()
    .trim()
    .min(1, 'Name is required.')
    .max(50, { message: 'Name must be less than 50 characters.' }),
  email: z.string()
    .trim()
    .min(1, 'Email is required.')
    .email('Must be a valid email address.')
    .min(5, 'Must be a valid email address.')
    .max(255, 'Email must be less than 255 characters.'),
  zipCode: z.string()
    .trim()
    .min(5, 'Zip code must be 5 digits.')
    .max(5, 'Zip code must be 5 digits.')
    .regex(/^\d{5}$/, 'Zip code must be 5 digits.').or(z.string().max(0)),
  city: z.string()
    .trim()
    .max(100, { message: 'City must be less than 100 characters.' })
    .optional()
    .or(z.literal('')),
  stateId: z.number().nullish().optional(),
  enabledFeaturesCapsule: z.array(z.string()),
  enabledFeaturesMobile: z.array(z.string())
});

export type CreateUpdateClientUserFormSchema = z.infer<typeof createUpdateClientUserFormSchema>;
export type CreateUpdateClientUserWithGeoFormSchema = z.infer<typeof createUpdateClientUserWithGeoFormSchema>;
